/**
 * Terminus Modal Component v1.0.0
 * https://www.figma.com/file/xCYAu1KMvIh06yCEg1AUzQ/Terminus-Design-System?node-id=28503%3A108844
 */
import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import {
  MatDialogModule,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faClose } from '@fortawesome/pro-solid-svg-icons';
import { ButtonComponent } from '@terminus-ui/button';

import { ModalService } from '../services/modal.service';
import { ModalButton, ModalData } from './../models/modal.types';

@Component({
  selector: 'tux-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  imports: [ButtonComponent, CommonModule, FontAwesomeModule, MatDialogModule],
})
export class ModalComponent {
  data = inject<ModalData>(MAT_DIALOG_DATA);
  private modalService = inject(ModalService);
  dialogRef = inject<MatDialogRef<ModalComponent>>(MatDialogRef);

  closeIcon = faClose;

  handleButtonClick(button: ModalButton): void {
    if (button.shouldClose) {
      this.dialogRef.close(button.text);
    }
    if (button.callbackFn) {
      button.callbackFn(this.dialogRef, this.modalService);
    }
  }
}
